import { Game } from "../types/game";
import { Rules, User } from "../types/user";

type GamePaymentScope = Pick<Game, "owner" | "organizers">;
type PaymentActor = Pick<User, "_id" | "rule">;

const idMatches = (ref: string | { _id?: string } | undefined, userId: string): boolean => {
  if (ref == null) return false;
  const id = typeof ref === "string" ? ref : ref._id;
  return id != null && String(id) === String(userId);
};

/** Game owner, listed organiser, or Schala admin — not players or unrelated organisers. */
export function userCanManageGamePayments(game: GamePaymentScope, user: PaymentActor): boolean {
  if (user.rule === Rules.Admin) return true;
  if (idMatches(game.owner as string | { _id?: string }, user._id)) return true;
  return (game.organizers || []).some(o => idMatches(o._id, user._id));
}

/** Received payments ledger — same gate as payment management (collecting organiser + admin). */
export const userCanViewReceivedPayments = userCanManageGamePayments;
